interface WidgetEmbedProps {
  url: string;
  title: string;
  width?: string;
  height: number;
}

export const WidgetEmbed = ({ url, title, width = '100%', height }: WidgetEmbedProps) => {
  return <iframe src={url} title={title} width={width} height={height} />;
};
